// extracted by mini-css-extract-plugin
export default {"container":"jOICvE","contentWrapper":"diflHi","divider":"EJZGhI","storeNameInput":"rnwIi3","templateFooter":"Map8fs","textDisclaimer":"jZYPEO"};